import "./index.scss";

import React from "react";
import MDatePicker from "react-datepicker";
import _ from "lodash";
import "react-datepicker/dist/react-datepicker.css";
import Popper from '@material-ui/core/Popper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import DateInput from "Components/common/Functions/DatePicker/DateInput/DateInput";
import moment from "moment";
import "./index.scss"
class Default extends React.Component {
    constructor(props) {
        super(props);

        this.inputRef = React.createRef();
        this.pickerInputRef = React.createRef();

        this.state = {
            anchorEl: null
        }
    }

    render() {
        const open = Boolean(this.state.anchorEl);

        const onOpen = () => {
            this.setState({
                ...this.state,
                anchorEl: this.pickerInputRef.current
            })
        }

        const handleClose = () => {
            this.setState({
                ...this.state,
                anchorEl: null
            });
        }
        
        const onChange = date => {
            
            if(this.props.onChange) {
                
                this.props.onChange(moment(date));
            }
        }

        const onBlur = e => {
            if(e) {
                onChange(e);
            } else {
                onChange(null);
            }
        }

        const handleInputChange = (date) => {
            onChange(date);
        }
       
        const isToday =this.props.selected?this.props.selected.isSame(new Date(), "day"):false
        const dateSelected =  new Date(this.props.selected.format())
        return (
            <div class={`default-picker-container ${this.props.disabled ? "disabled" : ""}`}>
                <div class="picker-input" ref={this.pickerInputRef} onClick={onOpen}>
                    {this.props.enableToday && this.state.anchorEl===null && isToday?
                    <div style={{ padding: "4px 5px 4px 30px"}}> Today</div>:
                    this.props.editable? 
                    <DateInput 
                    value={this.props.selected} 
                    onBlur={onBlur} 
                    onChange={handleInputChange}
                    dateFormat={this.props.dateFormat}/>
                    :<div style={{ padding: "4px 5px 4px 10px", width: "100px"}}> {this.props.selected.format(this.props.dateFormat)}</div>
                    
                }
                   
                    <a>
                        <i class={`material-icons`}>calendar_today</i>
                    </a>
                </div>
                <Popper open={open} anchorEl={this.state.anchorEl} placement="bottom-start" class={`defaultDatePicker ${this.props.popperClass}`} style={{zIndex: 1053}}>
                    <ClickAwayListener onClickAway={handleClose}>
                        
                        <MDatePicker
                            dateFormat="DD-MMM YYYY"
                            placeholderText="MM/DD/YYYY"
                            useWeekdaysShort={true}
                            name={this.props.name}
                            onChange={onChange}
                            class={this.props.classes}
                            ref={this.props.ref}
                            required={this.props.required}
                            disabled={this.props.disabled}
                            selected={dateSelected}
                            minDate={this.props.minDate}
                            renderDayContents={this.props.renderDayContents}
                            inline
                            showDisabledMonthNavigation
                        />
                    </ClickAwayListener>
                </Popper>
            </div>
        );
    }
}
Default.defaultProps = {
    editable: true 
  };
export default Default;